// API de la bandeja de notificaciones in-app. Ver CLAUDE.md §8.
import { api } from './api'
import type { DataResponse } from '@/types'

export interface AppNotification {
  id: string
  title: string
  body: string
  url: string | null
  work_order_id: string | null
  is_read: boolean
  created_at: string
}
export interface NotificationList {
  items: AppNotification[]
  unread: number
}

export async function getNotifications() {
  const { data } = await api.get<DataResponse<NotificationList>>('/notifications')
  return data.data
}

export async function markRead(id: string) {
  await api.post(`/notifications/${id}/read`)
}

export async function markAllRead() {
  await api.post('/notifications/read-all')
}
